import { Risk, Seriousness, WarningInCalendar } from '../../restapi/types';

function includeSomeWord(text: string, words: string[]): boolean {
	return words.some(w => text.includes(w));
}

function intersects<T>(A: T[], B: T[]): boolean {
	return A.some(v => B.includes(v));
}

export function filterCalendar(warnings: WarningInCalendar[], titleFilter: string, riskFilter: Risk[], seriousnessFilter: Seriousness[]) {
	const words = titleFilter.toLowerCase().split(' ').filter(p => !!p);  // non-empty words in titleFilter
	return warnings.filter(w => {
		const titleOk = !words.length || includeSomeWord((w.rb + ' - ' + w.title).toLowerCase(), words);
		const risksOk = !riskFilter.length || intersects(w.risks, riskFilter);
		const seriousnessOk = !seriousnessFilter.length || intersects([w.latestEvent.seriousness], seriousnessFilter);
		return titleOk && risksOk && seriousnessOk;
	});
}
